<hk-base-modal [hideApplyButton]="true" [hideCancelButton]="true" [title]="'RELEASE NOTES'">
  <div class="flex flex-col overflow-scroll">
    <div *ngFor="let note of releaseNotes; let i = index">
      <div class="border border-solid border-hk_gray-600 bg-white p-2.5">
        <div [ngClass]="{ 'text-hk_primary-600': isNewReleaseNote(note) }" class="mb-5">
          <span class="releaseNoteItemHeaderTitle">
            Version {{ note.version }}
            <span *ngIf="isNewReleaseNote(note)">- {{ getLocalizedTitle(note, '') }}</span>
          </span>
          <span class="block">{{ 'releaseNotes.releasedOn' | translate }}{{ note.releaseDate.toLocaleString() }}</span>
        </div>
        <div *ngFor="let feature of note.features" class="mt-5">
          <p class="!mt-0 whitespace-pre-wrap break-words font-bold">{{ getLocalizedFeature(feature, 'title', '') }}</p>
          <img
            *ngFor="let imageFilename of getLocalizedFeature(feature, 'imageFilenames', [])"
            alt="Geo Chart Module"
            class="mx-auto mt-1 block max-w-[calc(100%-2px)] border border-solid border-hk_gray-600"
            src="media/connected/releaseNotes/{{ note.version }}/{{ imageFilename }}"
          />
          <video
            *ngFor="let videoUrl of getLocalizedFeature(feature, 'videoUrls', [])"
            class="scale-down mx-auto mt-1 block max-w-[calc(100%-2px)] border border-solid border-hk_gray-600"
            controls
            controlsList="nodownload"
            disablePictureInPicture="true"
            oncontextmenu="return false;"
            playsinline
            webkit-playsinline
          >
            <source [src]="videoUrl" type="video/mp4" />
            <p>{{ 'help.noVideoSupport' | translate }}</p>
          </video>
          <p class="!mb-0 !mt-1 !whitespace-pre-wrap !break-words">{{ getLocalizedFeature(feature, 'text', '') }}</p>
        </div>
      </div>
    </div>
  </div>
</hk-base-modal>
